// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textBlock[data-v-8df4b76c]{padding:30px;font-style:normal;font-weight:400;font-size:18px;line-height:24px;color:#686868;text-align:justify}.textBlock .bookmark[data-v-8df4b76c]{background:url(/img/icons/bookmark-icon-4.png);background-repeat:no-repeat;display:block;width:100px;height:100px;background-size:100px 75px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
